import { FC } from "react";
import { Box, Typography } from "@material-ui/core";
import { Cancel as CancelIcon } from "@material-ui/icons";

import { Modal } from "components";
import theme from "theme";
import { circleIconSize } from "theme/constants";

interface ListPriceRequiredModalProps {
  onClose: () => void;
}

const ListPriceRequiredModal: FC<ListPriceRequiredModalProps> = ({
  onClose,
}) => (
  <Modal title="Set a List Price" open onClose={onClose}>
    <Typography component="div">
      <Box textAlign="center">
        <CancelIcon
          style={{
            fontSize: circleIconSize.big,
            color: theme.custom.palette.red.main,
          }}
        />
      </Box>
      <Box fontSize={15} textAlign="center" m={2}>
        A list price is required to feature your listing.
      </Box>
    </Typography>
  </Modal>
);

export default ListPriceRequiredModal;
